import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import Read from './components/Read/Read';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Resources from './components/Resources/Resources';
import { OfflineRead } from './components/Offline/OfflineRead';
import { OfflineLinks } from './components/Offline/OfflineLinks';
import StudyWatchVideo from './components/Study/StudyWatchVideo';
import StudyMCQStudent from './components/Study/StudyMCQStudent';
import CommonInsights from './components/Insights/CommonInsights';
import StudyMCQProfessor from './components/Study/StudyMCQProfessor';
import StudyReadExplanation from './components/Study/StudyReadExplanation';
import StudyCenterProfessor from './components/Study/StudyCenterProfessor';
import StudyIssueSpotStudent from './components/Study/StudyIssueSpotStudent';
import StudyFlashCardStudent from './components/Study/StudyFlashCardStudent';
import StudyCenterLandingPage from './components/Study/StudyCenterLandingPage';
import StudyIssueSpotProfessor from './components/Study/StudyIssueSpotProfessor';
import StudyFlashCardProfessor from './components/Study/StudyFlashCardProfessor';
import StudyShortAnswerStudent from './components/Study/StudyShortAnswerStudent';
import StudyShortAnswerProfessor from './components/Study/StudyShortAnswerProfessor';
import ConnectedQuizStudent from './components/ConnectedQuizStudent/ConnectedQuizStudent';
import PPClasses from './components/ConnectedPracticePerfect/PracticePerfectClasses/PPClasses';
import ConnectedQuizProfessor from './components/ConnectedQuizProfessor/ConnectedQuizProfessor';
import PPGradedQuiz from './components/ConnectedPracticePerfect/PracticePerfectVideos/PPQuizTaker/PPGradedQuiz';
import PPWatchVideo from './components/ConnectedPracticePerfect/PracticePerfectVideos/PPWatchVideo/PPWatchVideo';
import PPQuizResult from './components/ConnectedPracticePerfect/PracticePerfectVideos/PPQuizResult/PPQuizResult';
import PPBuildYourOwnQuiz from './components/ConnectedPracticePerfect/PracticePerfectQuizzes/PPBuildYourOwnQuiz';
import PPPracticeQuiz from './components/ConnectedPracticePerfect/PracticePerfectVideos/PPQuizTaker/PPPracticeQuiz';
import PPComparativeQuizzes from './components/ConnectedPracticePerfect/PracticePerfectQuizzes/PPComparativeQuizzes';
import PracticePerfectVideos from './components/ConnectedPracticePerfect/PracticePerfectVideos/PracticePerfectVideos';
import PracticePerfectQuizzes from './components/ConnectedPracticePerfect/PracticePerfectQuizzes/PracticePerfectQuizzes';
import PPClassStudentsDetails from './components/ConnectedPracticePerfect/PracticePerfectClasses/PPClassStudentsDetails';
import PracticePerfectProgress from './components/ConnectedPracticePerfect/PracticePerfectProgress/PracticePerfectProgress';
import PPClassStudentSubTopicPage from './components/ConnectedPracticePerfect/PracticePerfectClasses/PPClassStudentSubTopicPage';
import PPClassStudentsTopicScores from './components/ConnectedPracticePerfect/PracticePerfectClasses/PPClassStudentsTopicScores';
import PPPreviouslyWatchedQuizzes from './components/ConnectedPracticePerfect/PracticePerfectQuizzes/PPPreviouslyWatchedQuizzes';
function CasebookConnect(props) {
    const [online, setIsOnline] = useState();
    const [loading, setLoading] = useState(true);
    useEffect(async () => {
        await isOnline()
        window.addEventListener("online", isOnline);
        window.addEventListener("offline", isOnline);
        return () => {
            window.removeEventListener("online", isOnline);
            window.removeEventListener("offline", isOnline);
        };
    }, []);
    const isOnline = async () => {
        return fetch(`${localStorage.getItem('qpAPI')}/api/welcome?${Date.now()}`)
            .then(function () {
                setIsOnline(true);
                setLoading(false);
            }).catch(function (error) {
                setIsOnline(false);
                setLoading(false);
            });
    }
    const [loggedInStatus, setLoggedInStatus] = useState(false);
    const applicationState = (object) => { setLoggedInStatus(object); }
    return (
        <div className="main">
            <Switch>
                <Route exact path="/">
                    <Login {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/login">
                    <Login {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route path="/logout" component={() => { window.location = window.location.origin; return null; }} />
                <Route path="/myDashboard" component={() => { window.location = window.location.origin; return null; }} />
                <Route exact path="/dashboard">
                    <Dashboard {...props} actions={{ setApplicationState: applicationState }}></Dashboard>
                </Route>
                <Route exact path="/cq-student">
                    <ConnectedQuizStudent {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/cq-professor">
                    <ConnectedQuizProfessor {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-video-library/:isbn"  >
                    <PracticePerfectVideos {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-video-library/:isbn/video/:subtopictagid"  >
                    <PPWatchVideo {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-classes/:isbn"  >
                    <PPClasses {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-classes/:isbn/pp-studentsdetails"  >
                    <PPClassStudentsDetails {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-classes/:isbn/pp-studentstopicscores"  >
                    <PPClassStudentsTopicScores {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-classes/:isbn/pp-subtopicpage"  >
                    <PPClassStudentSubTopicPage {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-quiz/practice/:isbn/:subtopictagid/:subjectareatagid/:videoType"  >
                    <PPPracticeQuiz {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-quiz/graded/:isbn/:subtopictagid/:subjectareatagid/:videoType"  >
                    <PPGradedQuiz {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-quiz/results/:isbn/:subtopictagid/:subjectareatagid/:quizinstanceid"  >
                    <PPQuizResult {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-quiz-center/:isbn"  >
                    <PracticePerfectQuizzes {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-quiz-center/previously-watched/:isbn"  >
                    <PPPreviouslyWatchedQuizzes {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-quiz-center/build-your-own/:isbn"  >
                    <PPBuildYourOwnQuiz {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-quiz-center/comparative/:isbn"  >
                    <PPComparativeQuizzes {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/pp-progress/:isbn"  >
                    <PracticePerfectProgress {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/read/users/:userId/books/:isbn/:chapterid">
                    {
                        !loading ?
                            online ?
                                <Read {...props} actions={{ setApplicationState: applicationState }} /> :
                                <OfflineRead {...props} actions={{ setApplicationState: applicationState }} />
                            :
                            null
                    }
                </Route>
                <Route exact path="/offline-links">
                    <OfflineLinks {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid">
                    <StudyCenterLandingPage {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn">
                    <StudyCenterProfessor {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/mcq/:loid">
                    <StudyMCQStudent {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/mcqreview/:loid">
                    <StudyMCQProfessor {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/flashcard/:loid">
                    <StudyFlashCardStudent {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/flashcardreview/:loid">
                    <StudyFlashCardProfessor {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/shortanswer/:loid">
                    <StudyShortAnswerStudent {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/shortanswerreview/:loid">
                    <StudyShortAnswerProfessor {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/essay/:loid">
                    <StudyShortAnswerStudent {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/essayreview/:loid">
                    <StudyShortAnswerProfessor {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/issuespotting/:loid">
                    <StudyIssueSpotStudent {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/issuespottingreview/:loid">
                    <StudyIssueSpotProfessor {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/watchvideo/:loid">
                    <StudyWatchVideo {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/study/:isbn/:chapterid/readexplanation/:loid">
                    <StudyReadExplanation {...props} actions={{ setApplicationState: applicationState }} />
                </Route>
                <Route exact path="/insights/:isbn" component={CommonInsights} />
                <Route exact path="/resources/:isbn" component={Resources} />
            </Switch>
            {
                (!loggedInStatus) ?
                    <div className="row">
                        <div className="container">
                            <div className="col-12 col-lg-10 col-md-8 col-sm-6 mx-auto text-center">
                            </div>
                        </div>
                    </div>
                    : null
            }
        </div>
    );
}
export default CasebookConnect;
